export default __webpack_public_path__ + "static/media/include_0_male@3x.428528b6.jpg";